import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../store';
import { closeFeedbackSentPopup } from '../../../actions/feedback';
import { PopupFeedbackSent } from './PopupFeedbackSent';

export const PopupFeedbackSentContainer = connect(
  (state: IState) => ({
    isOpen: state.feedback.isFeedbackSentPopupOpened,
  }),
  (dispatch: Dispatch<{}>) => ({
    onClose() {
      dispatch(closeFeedbackSentPopup());
    },
  }),
)(PopupFeedbackSent);
